import React from 'react';
import { Link } from 'react-router';
import LazyLoad from 'react-lazyload';

import { Button, Image } from 'shared/lib/SureDesignSystem';
import Offerings from './Offerings';
import Review from '../Review';
import Footer from '../Footer';

import heroSrc from './assets/hero/hero.png';
import heroSrcWebp from './assets/hero/hero.webp';
import solutionsGridItemSrc1 from './assets/solutions/solutions-grid-1.png';
import solutionsGridItemSrc2 from './assets/solutions/solutions-grid-2.png';
import solutionsGridItemSrc3 from './assets/solutions/solutions-grid-3.png';
import solutionsGridItemSrc4 from './assets/solutions/solutions-grid-4.png';
import solutionsGridItemSrc1Webp from './assets/solutions/solutions-grid-1.webp';
import solutionsGridItemSrc2Webp from './assets/solutions/solutions-grid-2.webp';
import solutionsGridItemSrc3Webp from './assets/solutions/solutions-grid-3.webp';
import solutionsGridItemSrc4Webp from './assets/solutions/solutions-grid-4.webp';
import carrierSrc1 from './assets/carriers/farmers.png';
import carrierSrc2 from './assets/carriers/markel.png';
import carrierSrc3 from './assets/carriers/assurant.png';
import carrierSrc4 from './assets/carriers/chubb.png';
import carrierSrc1Webp from './assets/carriers/farmers.webp';
import carrierSrc2Webp from './assets/carriers/markel.webp';
import carrierSrc3Webp from './assets/carriers/assurant.webp';
import carrierSrc4Webp from './assets/carriers/chubb.webp';

import styles from './LandingCarrier.module.css';

const LandingCarrier = () => {
  return (
    <div>
      <section className={styles.hero}>
        <div className={styles.hero_container}>
          <div className={styles.hero_grid}>
            <div>
              <h2 className={styles.hero_eyebrow}>
                SURE PLATFORM FOR CARRIERS
              </h2>
              <h1 className={styles.hero_title}>
                Modernize Your Insurance Stack
              </h1>
              <p className={styles.hero_description}>
                Enhance your customer experience and digital distribution
                capabilities by deploying award-winning technology in record
                time using the SURE Platform.
              </p>
              <Link to="/contact">
                <Button secondary className={styles.hero_button}>
                  contact sales
                </Button>
              </Link>
            </div>

            <Image
              className={styles.hero_image}
              src={heroSrc}
              webp={heroSrcWebp}
              alt="Apartments"
            />
          </div>
        </div>
      </section>

      <section className={styles.solutions}>
        <div className={styles.solutions_container}>
          <h2 className={styles.solutions_title}>Solutions, Not Software.</h2>
          <p className={styles.solutions_description}>
            Don’t get lost in the maze of insurance software platforms,
            licenses, and complex integrations.
          </p>
          <ul className={styles.solutions_grid}>
            <li className={styles.solutions_gridItem}>
              <p className={styles.solutions_gridTitle}>Digital Underwriting</p>
              <LazyLoad height={181} once>
                <Image
                  className={styles.solutions_gridImage}
                  src={solutionsGridItemSrc1}
                  webp={solutionsGridItemSrc1Webp}
                  alt="Digital Underwriting"
                />
              </LazyLoad>
            </li>
            <li className={styles.solutions_gridItem}>
              <p className={styles.solutions_gridTitle}>
                Instant
                <br />
                Claims
              </p>
              <LazyLoad height={181} once>
                <Image
                  className={styles.solutions_gridImage}
                  src={solutionsGridItemSrc2}
                  webp={solutionsGridItemSrc2Webp}
                  alt="Instant Claims"
                />
              </LazyLoad>
            </li>
            <li className={styles.solutions_gridItem}>
              <p className={styles.solutions_gridTitle}>
                Cloud Policy Administration
              </p>
              <LazyLoad height={181} once>
                <Image
                  className={styles.solutions_gridImage}
                  src={solutionsGridItemSrc3}
                  webp={solutionsGridItemSrc3Webp}
                  alt="Cloud Policy Administration"
                />
              </LazyLoad>
            </li>
            <li className={styles.solutions_gridItem}>
              <p className={styles.solutions_gridTitle}>
                Omnichannel Operations
              </p>
              <LazyLoad height={181} once>
                <Image
                  className={styles.solutions_gridImage}
                  src={solutionsGridItemSrc4}
                  webp={solutionsGridItemSrc4Webp}
                  alt="Omnichannel Operations"
                />
              </LazyLoad>
            </li>
          </ul>
        </div>
      </section>

      <section className={styles.tagline}>
        <div className={styles.tagline_container}>
          <h2 className={styles.tagline_title}>
            SURE Platform works seamlessly with existing on-premise and legacy
            systems.
          </h2>
        </div>
      </section>

      <section className={styles.focus}>
        <div className={styles.focus_container}>
          <h2 className={styles.focus_title}>
            You focus on your product & customers. We’ll manage everything else.
          </h2>
        </div>
      </section>

      <Offerings />

      <Review
        className={styles.review}
        review={{
          content:
            "Chubb's insurance offering, through SURE's technology platform, further reinforces our commitment to innovative, digital solutions and providing consumers with peace of mind.",
          author: 'James Walloga',
          position: 'EVP Accident & Health, Chubb North America',
          logo: require('./assets/logo-chubb.png'),
        }}
      />

      <section className={styles.carriers}>
        <div className={styles.carriers_container}>
          <h2 className={styles.carriers_title}>
            Join the industry leading carriers Built on SURE.
          </h2>
          <ul className={styles.carriers_logos}>
            <li>
              <LazyLoad height={75} once>
                <Image webp={carrierSrc1Webp} src={carrierSrc1} alt="Farmers" />
              </LazyLoad>
            </li>
            <li>
              <LazyLoad height={75} once>
                <Image webp={carrierSrc2Webp} src={carrierSrc2} alt="Markel" />
              </LazyLoad>
            </li>
            <li>
              <LazyLoad height={75} once>
                <Image
                  webp={carrierSrc3Webp}
                  src={carrierSrc3}
                  alt="Assurant"
                />
              </LazyLoad>
            </li>
            <li>
              <LazyLoad height={75} once>
                <Image webp={carrierSrc4Webp} src={carrierSrc4} alt="Chubb" />
              </LazyLoad>
            </li>
          </ul>
        </div>
      </section>

      <section className={styles.contact}>
        <div className={styles.contact_container}>
          <h2 className={styles.contact_title}>
            Learn more about SURE Platform.
          </h2>
          <Link to="/contact">
            <Button className={styles.contact_button}>contact sales</Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingCarrier;
